import { useQuery } from "@tanstack/react-query";
import { fetchBranchVersions } from "../api/fetch-branch-versions";
import { isBranchForbiddenError } from "~/shared/api/branch-access";

export const BRANCH_VERSIONS_QUERY_KEY = "branchVersions";

export function useBranchVersions(branchUid: string | undefined) {
  return useQuery({
    queryKey: [BRANCH_VERSIONS_QUERY_KEY, branchUid],
    queryFn: () => fetchBranchVersions(branchUid!),
    enabled: Boolean(branchUid),
    // 권한 없는 매장은 재시도해도 결과가 안 바뀐다 — 3번 더 찔러 화면만 늦게 뜬다
    retry: (failureCount, error) =>
      !isBranchForbiddenError(error) && failureCount < 3,
  });
}
